
  <div class="filter-container">
    <form [formGroup]="byTitleForm" (ngSubmit)="apply()">
      <div class="title">
        <span id="icon" class="material-icons-outlined">title</span>
        <label>Title:</label>
      </div>

      <div formArrayName="titles">
        <div
          class="sgc"
          *ngFor="let titleCtrl of titles.controls; let i = index"
        >
          <input
            type="text"
            [formControl]="titleCtrl"
            (click)="setEditingIndex(i)"
            minlength="3"
          />
        </div>
      </div>

      <button type="button" class="add-title-btn" (click)="addTitleField()">
        +
      </button>

      <not
        [filter]="byTitleFilter"
        (filterChanged)="onFilterChanged($event)"
      ></not>

      <button class="apply-filter-btn" type="submit">Apply</button>
    </form>
  </div>

